import { useHistory } from "react-router";
import routes from "../../helpers/routes";
import React from "react";
import "styled-components/macro";

export function useSubmissionMessage(actionName) {
  const history = useHistory();
  let anchorRoute;
  let anchorText;
  if (actionName === "booked") {
    anchorText = "Past Bookings";
    anchorRoute = routes.bookings;
  } else if (actionName === "skipping") {
    anchorText = "Past Skippings";
    anchorRoute = routes.skippings;
  } else if (actionName === "suspend") {
    anchorText = "Past Suspends";
    anchorRoute = routes.suspends;
  }
  const onClick = ev => {
    ev.preventDefault();
    history.push(anchorRoute);
  };
  const anchor = <a onClick={onClick}>"{anchorText}"</a>;
  return (
    <span>Great! Please visit the {anchor} page to view your submission.</span>
  );
}
